/* global BigInt */
function postPath(id) {
  if (!/^[1-9]\d{0,19}$/.test(String(id))) return null;
  return `/meme/${BigInt(String(id)).toString(36)}`;
}
function postIdFromPath(path) {
  const token = /^\/meme\/([a-z0-9]{1,13})\/?$/.exec(path)?.[1];
  if (!token) return null;
  let value = BigInt(0);
  for (const letter of token) value = value * BigInt(36) + BigInt(parseInt(letter, 36));
  const id = value.toString();
  return postPath(id) === `/meme/${token}` ? id : null;
}
function shareImage(post, fallback) {
  if (!post?.file_link || !/^https:\/\//.test(post.file_link)) return fallback;
  const url = new URL(post.file_link);
  if (url.hostname === 'res.cloudinary.com' && /\/(image|video)\/upload\//.test(url.pathname)) {
    const isVideo = url.pathname.includes('/video/upload/');
    url.pathname = url.pathname.replace('/upload/', `/upload/${isVideo ? 'so_0,' : ''}w_1200,c_limit,f_jpg,q_auto/`).replace(/\.[^./]+$/, '.jpg');
    return url.href;
  }
  return post.file_type === 'image' ? url.href : fallback;
}
export { postPath, postIdFromPath, shareImage };
